import { Injectable } from '@angular/core';
import { ExceptionService, PaginatedList, UtilsService } from '../../xform-compat';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RmsBasicCrudService } from '../components/rms-basic-crud.service';
import { SystemSettings } from '../../shared/models';
import { MarketSetting } from '../../shared/models/market-setting.inteface';


/**
 * Data service to handle system settings
 */
@Injectable({
  providedIn: 'root'
})
export class SystemSettingsService extends RmsBasicCrudService<any> {

  constructor(
    http: HttpClient,
    utilsService: UtilsService,
    exceptionService: ExceptionService
  ) {
    super(http, utilsService, exceptionService);
  }

  /**
   * Gets paginated list of system settings cut off
   * @returns {Observable<PaginatedList<SystemSettings>>}
   */
  public getSettings (params: any): Observable<PaginatedList<SystemSettings>> {
    return super.getData('/api/rms/systemsettings', params);
  }

  /**
   * update system settings values
   * @param id
   * @param body
   * @returns {Observable<SystemSettings>}
   */
  public updateSystemSettings (id: number, body: any): Observable<SystemSettings> {
    return super.updateData(`/api/rms/systemsettings/${id}`, body);
  }

  /**
   * Gets the market status
   * @returns {Observable<MarketSetting>}
   */
  public getMarketSettings (): Observable<MarketSetting> {
    return super.getData('/api/rms/market/info');
  }

}
